import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  GraduationCap, 
  Search, 
  Calendar, 
  MapPin, 
  Filter, 
  CheckCircle2, 
  Sparkles, 
  Compass 
} from 'lucide-react';

const mdpData = [
  {
    title: "Executive Management Programme in Advanced Strategic Management (Online)",
    period: "11th April 2025 – 10th January 2026",
    year: "2025 – 2026",
    status: "Ongoing",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online / Hybrid"
  },
  {
    title: "Executive Management Programme in Advanced Strategic Management (Online)",
    period: "July 2024 – April 2025",
    year: "2024 – 2025",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online"
  },
  {
    title: "Executive Management Programme in Advanced Strategic Management (Online)",
    period: "January 2024 – September 2024",
    year: "2024",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online"
  },
  {
    title: "Executive Management Programme in Advanced Strategic Management (Online)",
    period: "August 2022 – August 2023",
    year: "2022 – 2023",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Transformation, & Business Analytics (Online)",
    period: "6th Jan – 7th Dec, 2022",
    year: "2022",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Marketing, & Business Analytics (Online)",
    period: "28th Aug – 12th Dec, 2021",
    year: "2021",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Online"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Marketing, & Business Analytics",
    period: "4th Jan – 7th June, 2020",
    year: "2020",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Executive Classroom"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Marketing, & Business Analytics",
    period: "7th Jan – 10th June, 2019",
    year: "2019",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Executive Classroom"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Marketing, & Business Analytics",
    period: "6th Jan – 30th June, 2018",
    year: "2018",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Executive Classroom"
  },
  {
    title: "Executive Management Programme in Strategic Innovations, Digital Marketing, & Business Analytics",
    period: "5th Jan – 6th June, 2017",
    year: "2017",
    status: "Completed",
    category: "Executive Long-Term Programmes",
    institution: "DMS, IIT Delhi",
    mode: "Executive Classroom"
  },
  {
    title: "International Conference on Strategies in Volatile and Uncertain Environment for Emerging Markets",
    period: "14th – 15th July, 2017",
    year: "2017",
    status: "Completed",
    category: "Conferences & Conclaves",
    institution: "IIT Delhi & Global Partners",
    mode: "Conference Chair / Keynote"
  },
  {
    title: "Certificate Programme in Management: Strategy & Leadership in VUCA Environment",
    period: "4th – 6th March 2017",
    year: "2017",
    status: "Completed",
    category: "Specialized Leadership Certifications",
    institution: "IIT Delhi",
    mode: "Executive Intensive"
  },
  {
    title: "Sixteenth Global Conference on Flexible Systems Management",
    period: "4th – 6th Dec, 2016",
    year: "2016",
    status: "Completed",
    category: "Conferences & Conclaves",
    institution: "University of Technology Sydney (UTS), Australia",
    mode: "Global Symposium"
  },
  {
    title: "Start Up India Conclave – Entrepreneurship Development in India's North East",
    period: "29th November, 2016",
    year: "2016",
    status: "Completed",
    category: "Conferences & Conclaves",
    institution: "National Mission / IIT Delhi",
    mode: "National Conclave"
  },
  {
    title: "Coordinator: TEQIP-II on 'Strategic Innovation and Flexibility'",
    period: "Dec 3 – 4, 2015",
    year: "2015",
    status: "Completed",
    category: "Faculty & Institutional Development",
    institution: "DMS, IIT Delhi",
    mode: "TEQIP-II National Programme"
  },
  {
    title: "Faculty: TEQIP-II on 'Data Analytics'",
    period: "December 2015",
    year: "2015",
    status: "Completed",
    category: "Faculty & Institutional Development",
    institution: "IIT Delhi",
    mode: "Technical Faculty Development"
  },
  {
    title: "Faculty: Management Development Programme for Senior Indian Navy Officers",
    period: "July 2014",
    year: "2014",
    status: "Completed",
    category: "Defence & Public Sector MDPs",
    institution: "Indian Institute of Technology Delhi",
    mode: "Strategic Leadership for Defence"
  },
  {
    title: "MDP Coordinator for Child Development Project Officers (CDPOs), ICDS",
    period: "Dec 2013 – March 2014",
    year: "2013 – 2014",
    status: "Completed",
    category: "Defence & Public Sector MDPs",
    institution: "ICDS, Government of Bihar",
    mode: "Public Sector Leadership"
  },
  {
    title: "Management Development Programme for DPOs and CDPOs of ICDS",
    period: "2013",
    year: "2013",
    status: "Completed",
    category: "Defence & Public Sector MDPs",
    institution: "Government of Bihar",
    mode: "Governance & Administration"
  }
];

const categories = [
  "All",
  "Executive Long-Term Programmes",
  "Conferences & Conclaves",
  "Specialized Leadership Certifications",
  "Defence & Public Sector MDPs",
  "Faculty & Institutional Development"
];

export default function MDPs() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredMDPs = useMemo(() => {
    return mdpData.filter((item) => {
      const matchesCategory = selectedCategory === "All" || item.category === selectedCategory;
      const matchesSearch = 
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.institution.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.year.includes(searchTerm) ||
        item.mode.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [searchTerm, selectedCategory]);

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-4 mb-5">
        <div className="col-12 col-lg-8">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 bg-dark border border-secondary border-opacity-50">
            <GraduationCap className="text-info" size={16} />
            <span className="small text-light fw-medium">Executive Education & Capacity Building</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Management Development Programmes <br className="d-none d-md-block" />
            <span style={{ color: '#00f2fe' }}>(MDPs) & Conferences</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Executive leadership training, high-level armed forces programmes, and international conferences delivered across DMS IIT Delhi, central ministries, and corporate institutions.
          </p>

          {/* Quick Metrics Bar */}
          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 bg-dark border border-secondary border-opacity-25 text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-info">18+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Flagship MDPs</span>
            </div>
            <div className="p-3 rounded-3 bg-dark border border-secondary border-opacity-25 text-center">
              <span className="fs-4 fw-bold text-warning">Defence & Govt</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Senior Officer Training</span>
            </div>
            <div className="p-3 rounded-3 bg-dark border border-secondary border-opacity-25 text-center">
              <span className="fs-4 fw-bold text-light">2013 – 2026</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Active Executive Delivery</span>
            </div>
          </div>
        </div>

        {/* Center-aligned Pedagogy Card */}
        <div className="col-12 col-lg-4">
          <div 
            className="p-4 rounded-4 text-center border border-secondary border-opacity-50 h-100 d-flex flex-column align-items-center justify-content-center"
            style={{ background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(10px)' }}
          >
            <Compass className="text-info mb-3 mx-auto d-block" size={40} />
            <h5 className="text-white fw-bold mb-2">Executive Pedagogy</h5>
            <p className="text-secondary small mb-0 lh-base">
              Integrating strategic ambidexterity, digital transformation, and VUCA leadership for C-suite decision-makers.
            </p>
          </div>
        </div>
      </div>

      {/* 2. Search & Category Filters */}
      <div 
        className="p-4 rounded-4 mb-5 border border-secondary border-opacity-25"
        style={{ background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(10px)' }}
      >
        <div className="row g-3 align-items-center justify-content-between">
          <div className="col-12 col-md-5">
            <div className="position-relative">
              <Search className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" size={18} />
              <input
                type="text"
                placeholder="Search MDPs by keyword, year, or cohort..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
              />
            </div>
          </div>

          <div className="col-12 col-md-auto text-md-end text-secondary small">
            Showing <strong className="text-white">{filteredMDPs.length}</strong> of {mdpData.length} programmes
          </div>
        </div>

        {/* Filter Badges with explicit highlight state */}
        <div className="d-flex flex-wrap gap-2 mt-3 pt-3 border-top border-secondary border-opacity-25 align-items-center">
          <div className="d-flex align-items-center gap-1 text-secondary small me-2">
            <Filter size={14} /> Domain:
          </div>
          {categories.map((cat, idx) => {
            const isSelected = selectedCategory === cat;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => setSelectedCategory(cat)}
                className="btn btn-sm rounded-pill px-3 py-1 transition-all"
                style={{
                  fontSize: '0.8rem',
                  fontWeight: isSelected ? '700' : '500',
                  color: isSelected ? '#0a0f1d' : '#94a3b8',
                  background: isSelected ? 'linear-gradient(135deg, #00f2fe, #4facfe)' : 'rgba(255, 255, 255, 0.05)',
                  border: isSelected ? '1px solid #00f2fe' : '1px solid rgba(255, 255, 255, 0.15)',
                  boxShadow: isSelected ? '0 0 14px rgba(0, 242, 254, 0.45)' : 'none'
                }}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>

      {/* 3. Responsive MDP Cards Grid */}
      <div className="row g-3">
        <AnimatePresence>
          {filteredMDPs.map((item, index) => {
            const isOngoing = item.status === "Ongoing";

            return (
              <motion.div
                layout
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25 }}
                key={`${item.title}-${index}`}
                className="col-12 col-lg-6"
              >
                <div 
                  className="p-4 rounded-4 h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                  style={{
                    background: 'rgba(15, 23, 42, 0.85)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderLeft: isOngoing 
                      ? '4px solid #00f2fe' 
                      : '4px solid rgba(255, 255, 255, 0.25)'
                  }}
                >
                  <div>
                    {/* Badge Row */}
                    <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
                      <span 
                        className="badge px-3 py-1 rounded-pill"
                        style={{
                          fontSize: '0.75rem',
                          background: 'rgba(255, 255, 255, 0.06)',
                          color: '#94a3b8',
                          border: '1px solid rgba(255, 255, 255, 0.12)'
                        }}
                      >
                        {item.category}
                      </span>

                      {/* Visible Ongoing vs Completed indicator */}
                      {isOngoing ? (
                        <span 
                          className="badge px-3 py-1 rounded-pill d-inline-flex align-items-center gap-1"
                          style={{
                            backgroundColor: '#f59e0b',
                            color: '#0a0f1d',
                            fontWeight: '700',
                            letterSpacing: '0.03em',
                            fontSize: '0.75rem',
                            boxShadow: '0 0 10px rgba(245, 158, 11, 0.4)'
                          }}
                        >
                          <Sparkles size={12} color="#0a0f1d" /> Ongoing
                        </span>
                      ) : (
                        <span className="text-secondary small d-inline-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
                          <CheckCircle2 className="text-success" size={13} /> Completed
                        </span>
                      )}
                    </div>

                    <h5 className="text-white fw-bold fs-6 mb-2 lh-base">
                      {item.title}
                    </h5>

                    <p className="small mb-3 text-info">
                      <strong className="text-light">Format / Delivery:</strong> {item.mode}
                    </p>
                  </div>

                  {/* Footer Meta Row */}
                  <div className="pt-3 mt-2 border-top border-secondary border-opacity-15 d-flex flex-wrap justify-content-between align-items-center gap-2 text-secondary small">
                    <div className="d-inline-flex align-items-center gap-1 text-light">
                      <MapPin className="text-info flex-shrink-0" size={14} />
                      <span>{item.institution}</span>
                    </div>

                    <div className="d-inline-flex align-items-center gap-1 text-warning">
                      <Calendar size={13} />
                      <span>{item.period}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>

        {filteredMDPs.length === 0 && (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No Management Development Programmes match your search criteria.</p>
          </div>
        )}
      </div>

    </div>
  );
}